import React from "react";
import { Offcanvas, Button, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
// import { clearCart, selectCartItems, selectCartTotal } from "../../../store/cartSlice";
import {
  selectCartItems,
  selectCartTotal,
  increaseQty,
  decreaseQty,
  removeItem,
  clearCart,
  updateQtyFromDropdown,
} from "../../../store/cartSlice";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../auth-pages/AuthContext";
import CheckoutButton from "./CheckoutButton";
import { useState } from "react";

const format = (v) => (Number(v) || 0).toLocaleString();

const CartDrawer = ({ show, onHide }) => {
  const { id } = useParams();
  // const fullState = useSelector((state) => state);
  const items = useSelector(selectCartItems);
  const total = useSelector(selectCartTotal);
  const dispatch = useDispatch();
  const pathUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const { auth } = useAuth();
  // const handleCheckout = () => {
  //   navigate(auth.isLoggedIn ? "/checkout" : "/login");
  // };

  // console.log("items", items);

  return (
    <Offcanvas show={show} onHide={onHide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>My Cart</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        {items.length === 0 ? (
          <div className="mt-2 text-center">
            <CheckoutButton />
          </div>
        ) : (
          <>
            {items.map((item) => (
              <div key={item.id} className="d-flex align-items-center mb-3">
                <img
                  src={pathUrl + item.image || "/assets/img/no-image.jpg"}
                  alt="img"
                  width={64}
                  height={64}
                  className="rounded me-2"
                  style={{ objectFit: "cover" }}
                />

                <div className="flex-grow-1">
                  <div className="fw-semibold">{item.name}</div>

                  {/* PRICE */}
                  <div className="text-dark mt-1">
                    ₹{" "}
                    {format(
                      item.isFixedQty
                        ? item.finalAmount
                        : item.qty * item.price,
                    )}
                  </div>

                  {/* QTY SECTION */}
                  <div className="mt-1">
                    {item.isFixedQty ? (
                      <div className="d-flex align-items-center">
                        <label className="me-2">Qty:</label>

                        <select
                          className="form-select form-select-sm"
                          style={{ width: "80px" }}
                          value={item.qty}
                          onChange={(e) => {
                            const selected = item.qtyRateList.find(
                              (q) => q.qty === Number(e.target.value),
                            );
                            if (!selected) return;

                            dispatch(
                              updateQtyFromDropdown({
                                id: item.id,
                                qty: selected.qty,
                                price: selected.price,
                                finalAmount: selected.finalAmount,
                                courierCharges: selected.courierCharges,
                              }),
                            );
                          }}
                        >
                          {item.qtyRateList.map((q) => (
                            <option key={q.productQtyRateMapID} value={q.qty}>
                              {q.qty}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center">
                        <button
                          className="btn btn-sm btn-outline-secondary me-2"
                          onClick={() => dispatch(decreaseQty(item.id))}
                        >
                          –
                        </button>

                        <span>{item.qty}</span>

                        <button
                          className="btn btn-sm btn-outline-secondary ms-2"
                          onClick={() => dispatch(increaseQty(item.id))}
                        >
                          +
                        </button>
                      </div>
                    )}
                  </div>
                </div>

                {/* RIGHT SIDE */}
                {/* <div className="text-end mt-4">
                  {item.isFixedQty ? (
                    <div>
                      {" "}
                      <span> Courior Charge: </span>₹{" "}
                      {format(item.courierCharges)}
                    </div>
                  ) : (
                    <div>₹ {format(item.qty * item.price)}</div>
                  )}
                  <button
                    className="btn btn-sm btn-link text-danger"
                    onClick={() => dispatch(removeItem(item.id))}
                  >
                    Remove
                  </button>{" "}
                </div> */}
              </div>
            ))}

            <hr />

            <div className="d-flex justify-content-between">
              <strong>Price:</strong>
              <strong>₹ {format(total)}</strong>
              <br />
            </div>
            <p className="text-success small">
              {" "}
              Price shown includes taxes and delivery charges.{" "}
            </p>
            <div className="d-flex  gap-2 mt-3 mx-2">
              {/* <button
                className="btn btn-danger"
                onClick={() => dispatch(clearCart())}
              >
                Clear
              </button> */}{" "}
              <button
                className="btn w-50"
                style={{
                  backgroundColor: "#dc3545", // Bootstrap red
                  color: "#fff",
                  border: "none",
                  height: "45px",
                  fontWeight: "500",
                }}
                onClick={() => dispatch(clearCart())}
              >
                Clear
              </button>
              <CheckoutButton />
            </div>
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CartDrawer;
